import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { OrderPanelStyled, PriceCss } from '../OrderPanelStyled';

export const OrderPanelStyledOV = styled(OrderPanelStyled)`
    .wrapper {
        color: ${({ theme }) => theme.colors.grey27};
        .section-divider {
            width: ${rem(2)};
        }
        .section {
            border-color: ${({ theme }) => theme.colors.grey16} !important;
            border-width: 1px !important;

            .order-panel-price-container {
                .calculator {
                    width: fit-content;
                    svg {
                        height: ${rem(31)};
                        margin-top: ${rem(5)};
                    }
                    .txt {
                        span {
                            display: inline-block;
                            margin-bottom: ${rem(4)};
                        }

                        &:hover,
                        &:focus-visible {
                            color: ${({ theme }) => theme.colors.black} !important;

                            span {
                                border-color: ${({ theme }) => theme.colors.black} !important;
                            }
                        }
                    }
                }
            }
        }
        .section {
            min-width: 38%;

            .order-panel-price-container {
                ${PriceCss}
                .calculator {
                    .txt {
                        font-size: ${({ theme }) => theme.fontSizes.textMedium};
                        &:focus-visible {
                            span {
                                border-color: ${({ theme }) => theme.colors.black};
                            }
                            color: ${({ theme }) => theme.colors.black};
                        }
                    }
                }
                .content {
                    .header {
                        font-size: ${({ theme }) => theme.fontSizes.textTiny};
                    }
                    .body {
                        .body-wrapper {
                            align-items: baseline;
                            .price {
                                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                            }
                            .or {
                                line-height: ${rem('23px')};
                            }
                            .footer {
                                font-size: ${({ theme }) => theme.fontSizes.textTiny};
                            }
                            .totalMonthlyPriceWrapper {
                                align-items: flex-end;

                                .infoIcon {
                                    .icon-wrapper {
                                        padding: 0px;

                                        svg {
                                            width: ${rem('22px')};
                                            height: ${rem('22px')};

                                            path {
                                                fill: ${({ theme }) => theme.colors.black};
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .section-middle {
            min-width: 21%;

            @media screen and (max-width: ${breakpoints.lg}px) {
                min-width: 30%;
            }
        }

        .section-end {
            @media screen and (max-width: ${breakpoints.lg}px) {
                min-width: 25%;
            }
        }
    }

    &.isShowPriceExcludedVAT-panel {
        .currencyLabel__suffix--OTR {
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
        }
    }

    .content {
        .body {
            .footer {
                max-width: ${rem(275)};
            }
        }
    }

    .desktopContactSection {
        .modalLink {
            color: ${({ theme }) => theme.colors.black2};
            border: 1px solid transparent;

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black2};
                    stroke: ${({ theme }) => theme.colors.black2};
                }
            }

            &:hover,
            &:focus-visible {
                border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
            }
        }

        .phoneLink {
            color: ${({ theme }) => theme.colors.black2};
        }
    }

    .mobileContactSection {
        background: ${({ theme }) => theme.colors.black2};
    }
`;
